<template>
    <div class="info-side-bar-container">
        <div class="info-card d-flex flex-column " :style="{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(${chat.logo})` }">
            <div class="d-flex align-items-start flex-column ms-3 info-container">
                <span class="mb-1 company-name">{{ chat.name }}</span>
                <span class="desc">{{ chat.description }}</span>
            </div>
        </div>
        <div>
            <div class="company-info-section">
                <div v-if="chat.phone" class="company-info">
                    <span class="comapny-info-title">تلفن: </span>
                    <a :href="'tel:' + chat.phone">
                        <span class="company-info-value">{{ chat.phone }}</span>
                    </a>
                </div>
                <div v-if="chat.email" class="company-info">
                    <span class="comapny-info-title">ایمیل: </span>
                    <a :href="'mailto:' + chat.email">
                        <span class="company-info-value">{{ chat.email }}</span>
                    </a>
                </div>
                <div v-if="chat.address" class="company-info">
                    <span class="comapny-info-title">آدرس: </span>
                    <span class="company-info-value">{{ chat.address }}</span>
                </div>
                <div v-if="chat.website" class="company-info">
                    <span class="comapny-info-title">وبسایت: </span>
                    <a :href="chat.website" target="_blank">
                        <span class="company-info-value">{{ chat.website }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        chat: Object
    },

}
</script>

<style scoped>

    .info-side-bar-container {
        background-color: #25292E;
        border: none;
        height: 100vh;
        width: 400px;
    }
    .info-card {
        height: 400px;
        /* border: 1px solid #ccc; */
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        justify-content: flex-end;
        align-items: flex-start;
    }

    .info-container {
        color: white;
        padding: 15px;
    }

    .company-name {
        font-size: 1.5rem;
        font-weight: bold;
    }

    .desc {
        font-size: 1rem;
    }

    .company-info-section {
        padding: 15px;
        padding-top: 30px;
        border-top: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 1.5;
        color: white;
    }

    .company-info {
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .company-info-title {
        font-weight: bold;
    }

    .company-info-value {
        color: #028D92;
        margin-right: 10px;
    }

    a {
        text-decoration: none;
    }
</style>